import { render, staticRenderFns } from "./ConfirmPlan.vue?vue&type=template&id=ff05a502&"
import script from "./ConfirmPlan.vue?vue&type=script&lang=js&"
export * from "./ConfirmPlan.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports